import { useState } from 'react';
import { Link } from 'react-router-dom';

import './register.css';
import { logo, subLogo, footerLogo } from '../../Assets/vacations';

export const CheckIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
);

export const PasswordField = ({ id, value, onChange, error, placeholder = 'At least 8 characters', autoComplete = 'new-password', minLength = 8 }) => {
    const [visible, setVisible] = useState(false);
    return (
        <div className="field">
            <label htmlFor={id}>Password</label>
            <div className="pw">
                <input id={id} name="password" type={visible ? 'text' : 'password'} autoComplete={autoComplete} minLength={minLength}
                    placeholder={placeholder} required value={value} onChange={onChange} />
                <button type="button" onClick={() => setVisible((v) => !v)}>{visible ? 'Hide' : 'Show'}</button>
            </div>
            {error && <div className="field-error">{error}</div>}
        </div>
    );
};

// Header + footer shared by the Register and Login screens (mockup layout).
export const AuthShell = ({ children }) => (
    <div className="vx-register">
        <header className="site-header">
            <div className="container header-inner">
                <div className="logo-cluster">
                    <a className="logo" href="https://kayifi.com"><img src={logo} alt="Kayifi" /></a>
                    <Link className="subdomain-btn" to="/" aria-current="page">Vacations</Link>
                </div>
                <Link className="sub-logo" to="/"><img src={subLogo} alt="Kayifi Vacations" /></Link>
                <div className="header-actions">
                    <a className="nav-home" href="https://kayifi.com">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /></svg>
                        Home
                    </a>
                    <Link className="btn btn-ghost btn-sm" to="/login">Sign In</Link>
                    <Link className="btn btn-primary btn-sm" to="/sign-up">Register</Link>
                </div>
            </div>
        </header>

        <main>{children}</main>

        <footer className="site-footer">
            <div className="container">
                <div className="footer-grid">
                    <div className="footer-brand">
                        <img src={footerLogo} alt="Kayifi Vacations" />
                        <p>vacations.kayifi.com — part of the Kayifi ecosystem. Your Tropical Connection.</p>
                    </div>
                    <div className="footer-col">
                        <h4>Kayifi Hub</h4>
                        <ul>
                            <li><a href="https://kayifi.com">Kayifi Home</a></li>
                            <li><a href="https://kayifi.com/en/properties">Properties</a></li>
                            <li><a href="https://services.kayifi.com/en">Services</a></li>
                            <li><a href="https://adventures.kayifi.com/en">Adventures</a></li>
                            <li><Link to="/">Vacations</Link></li>
                        </ul>
                    </div>
                    <div className="footer-col">
                        <h4>Get In Touch</h4>
                        <ul>
                            <li><a href="mailto:info@kayifi.com">info@kayifi.com</a></li>
                            <li><Link to="/sign-up">Register</Link></li>
                            <li><Link to="/login">Sign In</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>© {new Date().getFullYear()} Kayifi. All rights reserved.</p>
                    <nav className="footer-links" aria-label="Kayifi network">
                        <a href="https://kayifi.com/en/properties">Properties</a>
                        <a href="https://services.kayifi.com/en">Services</a>
                        <a href="https://adventures.kayifi.com/en">Adventures</a>
                        <Link to="/">Vacations</Link>
                    </nav>
                </div>
            </div>
        </footer>
    </div>
);
